import React from 'react'
import { CreateTable, TableStyles } from '../../components';
import { useEffect } from 'react';
import services from '../../../ioc/services';
import { useState } from 'react';



function AgentRecordsSummary() {


    const [agentsData, setAgentsData] = useState(null);

    useEffect(() => {
        services.api.agent.getAgents().then(res => {

            setAgentsData(res.map(agent => ({
                "Agent": agent.firstName + " " + agent.lastName,
                "Forms": agent.forms.length,
                "Responses": agent.responses.length
            })
            ))
        });
    }, [])

    const myData = [
        {
            "Agent": "Agent 1",
            "Forms": 10,
            "Responses": 10
        },
        {
            "Agent": "Agent 5",
            "Forms": 50,
            "Responses": 10
        },
    ]

    console.log("AG: ", agentsData)

    const headers = agentsData != null && agentsData.length > 0 && agentsData.at(0) != null ? Object.keys(agentsData.at(0)) : []

    const cd = headers.map(h => ({
        Header: h,
        accessor: h
    }))

    const columns = React.useMemo(() => cd, [agentsData])
    const data = React.useMemo(() => agentsData, [agentsData])

    return (
        <TableStyles>
            <CreateTable columns={columns} data={data} />
        </TableStyles>
    )

}

export default AgentRecordsSummary